'use strict';

import $ from 'jquery';

export default class NextInitiatives {
  constructor() {

    let $showChooseCalendar = $('*[data-js="showChooseCalendar"]');

    $showChooseCalendar.on('click', (event) => {
      event.preventDefault();
      const hasClass = $(event.delegateTarget).hasClass('show');
      $showChooseCalendar.removeClass('show');

      if ( hasClass ){
        $(event.delegateTarget).removeClass('show');
      }else{
        $(event.delegateTarget).addClass('show');
      }
    });

    let $calendarSelected = $('*[data-js="calendarSelected"]');
    
    $calendarSelected.on('click', (event) => {
      $(event.delegateTarget).parent().prev().removeClass('show');
    });
  }
}
